import { TypographyHeading } from "./Heading";
import { TypographyLink, TypographyText } from "./Text";
export function Typography(_a) {
    var children = _a.children;
    return children;
}
Typography.Text = TypographyText;
Typography.Link = TypographyLink;
Typography.Heading = TypographyHeading;
//# sourceMappingURL=Typography.js.map